import styled from "styled-components";

export const WidgetButton = styled.button`
  && {
    ${(props) => props?.theme?.themeConfig?.chatButton?.styles}

    height: 40px;
    width: 40px;
    bottom: 2.5px;

    svg {
      fill: white;
      width: unset;
      height: unset;
    }

    @media (min-width: 768px) {
      bottom: unset;
      height: ${(props) => props?.theme?.themeConfig?.chatButton?.styles.height};
      width: ${(props) => props?.theme?.themeConfig?.chatButton?.styles.width};
    }
  }
`;
